import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";
import { invalidateRecipeQueries } from "@/lib/recipeCacheKeys";
import { todayLocalDate } from "@/lib/dates";
import { notifyError } from "@/lib/toast";

interface UnlogTodayVars {
    recipeId: number;
}

/**
 * Undo: remove today's log entry for a recipe. The DB trigger recomputes
 * recipes.has_made_it (back to false if this was the only entry).
 */
export function useUnlogToday() {
    const queryClient = useQueryClient();

    return useMutation<void, Error, UnlogTodayVars>({
        mutationFn: async ({ recipeId }) => {
            const { error } = await supabase
                .from("recipe_logs")
                .delete()
                .eq("recipe_id", recipeId)
                .eq("made_on", todayLocalDate());

            if (error) throw error;
        },
        onError: () => {
            notifyError("Your entry wasn't removed. Try again.");
        },
        onSettled: (_data, _err, { recipeId }) => {
            invalidateRecipeQueries(queryClient, recipeId);
        }
    });
}
